import { workbenchStore } from '../../stores/workbench';

export function executeConfigureSession(args: {
  mode: string;
  skills?: string[];
}): string {
  workbenchStore.session.set({
    mode: args.mode,
    skills: args.skills || [],
  });
  return `Session configured: mode=${args.mode}, skills=[${(args.skills || []).join(',')}]`;
}
